import React, { useEffect } from "react";

const GoogleTranslate = () => {
  useEffect(() => {
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,fr,es,de,it,pt,zh-CN,ar",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element"
      );

      setTimeout(() => {
        const combo = document.querySelector(".goog-te-combo");
        if (combo) {
          combo.insertBefore(
            new Option("Translate", "", true, true),
            combo.firstChild
          );
          combo.value = "";
        }
      }, 1000);
    };

    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
<div
  id="google_translate_element"
  className="fixed top-20 right-4 z-50 bg-white shadow-lg rounded-lg p-2"
></div>
  );
};

export default GoogleTranslate;

